<template>
  <section class="py-12 px-4">
    <div class="max-w-5xl mx-auto">
      <!-- Header -->
      <div class="text-center mb-10">
        <h2 class="text-3xl font-bold text-gray-900 mb-2">
          {{ content.title }}
        </h2>
        <p class="text-gray-600 text-lg">
          {{ content.subtitle }}
        </p>
      </div>

      <!-- Steps -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          v-for="(step, i) in content.steps"
          :key="i"
          class="bg-blue-50 rounded-lg p-6 text-center"
        >
          <div
            class="w-14 h-14 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4"
          >
            <IconComponent
              :icon="step.icon || 'check'"
              class="w-7 h-7 text-white"
            />
          </div>
          <p class="text-sm font-semibold text-blue-600 mb-1">
            {{ step.stepLabel }}
          </p>
          <h3 class="text-lg font-bold text-gray-900 mb-2">
            {{ step.title }}
          </h3>
          <p class="text-gray-600 text-sm">
            {{ step.description }}
          </p>
        </div>
      </div>

      <!-- CTA button -->
      <div class="flex justify-center mt-10">
        <JoszakiButton
          type="info"
          :to="localePath({ name: 'requestForTenderTab', params: { activeTab: 1 } })"
        >
          {{ $t("landing.howItWorks.ctaButton") }}
        </JoszakiButton>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, useContext } from "@nuxtjs/composition-api";
import useModuleContent from "~/composables/useModuleContent";

export default {
  name: "HowItWorksModule",
  props: {
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { $posthog } = useContext();
    const { content } = useModuleContent(props);

    onMounted(() => {
      $posthog?.capture("front_page_module_viewed", {
        module_slug: props.moduleConfig.slug,
        module_position: props.moduleConfig.position,
        module_row: props.moduleConfig.row,
        version_id: props.moduleConfig.versionId,
      });
    });

    return { content };
  },
};
</script>
